import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesElectricityComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 2v6" fill="none" />
        <path d="M15 2v6" fill="none" />
        <path d="M12 17v5" fill="none" />
        <path d="M5 8h14" fill="none" />
        <path d="M6 11V8h12v3a6 6 0 1 1-12 0v0Z" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesElectricityComponent.displayName = 'IconAmenitiesElectricity';

const IconAmenitiesElectricity = React.memo(IconAmenitiesElectricityComponent);

export default IconAmenitiesElectricity;
